import { setContext } from 'apollo-link-context';
import * as Auth from '../libs/auth';

export default setContext(() => {
  const token = Auth.getAccessToken();

  if (!token) {
    return {};
  }

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
});
